import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import applicationConstants from '../../../../../Core/Utility/ApplicationConstants';
import formattingService from '../../../../Services/Formatting/FormattingService';
import languageService from '../../../../Services/Language/LanguageService';
import { translationKeys } from '../../../../Services/Language/TranslationDefinitions';

export const marginPositionsColumnDefinitions: ColDef[] = [
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.effectiveDate),
        field: 'salesDate',
        colId: 'salesDate',
        valueFormatter: (parameters: ValueFormatterParams) => {
            if (!parameters.value) {
                return applicationConstants.TablePlaceholderZeroOrEmpty;
            }

            return formattingService.toLongDayMonthYear(parameters.value);
        },
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.coveragePeriod),
        field: 'coveragePeriod',
        colId: 'coveragePeriod',
        valueGetter: (parameters: ValueGetterParams) =>
            formattingService.toLongDayMonthYear(parameters.data.coveragePeriodDate) || parameters.data.coverageQuarter,
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.pricingMethod),
        field: 'commodity',
        colId: 'commodity',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.subCommodity),
        field: 'subCommodity',
        colId: 'subCommodity',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.declaredProduction),
        field: 'declaredProduction',
        colId: 'declaredProduction',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.protectionFactor),
        field: 'protectionFactor',
        colId: 'protectionFactor',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.protectedProduction),
        field: 'protectedProduction',
        colId: 'protectedProduction',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.triggerPrice),
        field: 'triggerPrice',
        colId: 'triggerPrice',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.currentMarketPrice),
        field: 'currentMarketPrice',
        colId: 'currentMarketPrice',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.currentEstimatedIndemnity),
        field: 'currentEstimatedIndemnity',
        colId: 'currentEstimatedIndemnity',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.producerPremium),
        field: 'producerPremium',
        colId: 'producerPremium',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.estimatedNetToProducer),
        field: 'estimatedNetToProducer',
        colId: 'estimatedNetToProducer',
        cellClass: 'ag-right-aligned-cell',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.settlementDate),
        field: 'settlementDate',
        colId: 'settlementDate',
        valueFormatter: (parameters: ValueFormatterParams) => {
            if (!parameters.value) {
                return applicationConstants.TablePlaceholderZeroOrEmpty;
            }

            return formattingService.toLongDayMonthYear(parameters.value);
        },
    },
];

export const marginPositionsColumnOptions = {
    resizable: true,
    autoHeaderHeight: true,
    wrapHeaderText: true,
    flex: 1,
    rowDragManaged: true,
    animateRows: true,
    wrapText: true,
    suppressMenu: true,
    enableCellChangeFlash: true,
    headerClass: 'ag-header-cell-flex-start',
    comparator: () => 0,
    valueFormatter: (parameters: ValueFormatterParams) => {
        if (!parameters.value) {
            return applicationConstants.TablePlaceholderZeroOrEmpty;
        }

        return parameters.value;
    },
    sortable: true,
};
